module.exports = __webpack_public_path__ + "static/media/starFull.bcd45233.svg";